import React, {useContext} from 'react';
import {useAppStore} from "../../../../../GlobalStore/GlobalStore.ts";
import {MessageContext} from "../../Message.tsx";
import {canSeeImage} from "../../../../../Utils/misc/modelInsightUtils.ts";

interface ImageProps {
    item: {
        fileContent: string;
        fileName: string;
    };
}

const Image: React.FC<ImageProps> = ({ item }) => {
    const { isPreview } = useContext(MessageContext);
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    const handleImageClick = (imageSource: string) => {
        setDynamicStateObj({
            visiblePopup: "enlargedContent",
            enlargedContent: {type: "image", content: imageSource},
        });
    };
    const canSee = canSeeImage(settingsObj.model);

    return (
        <div className="flex-none bg-neutral-200 dark:bg-neutral-900">
            <button
                className="cursor-pointer relative"
                onClick={() => handleImageClick(item.fileContent)}
            >
                <img
                    className="my-3 mx-3 p-1 w-52 h-52 object-contain bg-black cursor-pointer rounded-lg"
                    src={item.fileContent}
                    alt="Message Image"
                />
                {(!isPreview && !canSee) && (
                    <>
                        <div className="absolute inset-0 bg-black bg-opacity-50" />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-black bg-opacity-75 text-white px-4 py-1 rounded text-sm">
                                Not supported by model
                            </div>
                        </div>
                    </>
                )}
            </button>
        </div>
    );
};

export default Image;
